import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  members: {
    id: 'studio.Sg9LAb',
    defaultMessage: 'Organization members',
  },
  membersError: {
    id: 'studio.pwempj',
    defaultMessage: 'There was a problem loading the members of this organization.',
  },
  addMembers: {
    id: 'studio.OCiHj6',
    defaultMessage: 'Add members',
  },
  name: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  actions: {
    id: 'studio.wL7VAE',
    defaultMessage: 'Actions',
  },
  notAllowed: {
    id: 'studio.kznIRT',
    defaultMessage: 'You don’t have sufficient permissions to invite members.',
  },
});
